<mat-toolbar color="primary" class="app-toolbar">
  <mat-toolbar-row>
    <mat-icon class="toolbar-icon" aria-hidden="true">account_balance</mat-icon>
    <span class="toolbar-school">{{ schoolDisplayName() }}</span>
    <span class="toolbar-tag">Portal</span>
    <span class="spacer"></span>
    <button mat-button type="button" (click)="logoutUser($event)">Logout</button>
  </mat-toolbar-row>
</mat-toolbar>
